import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom";
// Add custom style for popup margin
const datePickerPopupStyle = `
.custom-datepicker-popup,
.react-datepicker-popper,
.react-datepicker {
  z-index: 99999 !important; /* Even higher to ensure it's always on top */
  
}
.custom-datepicker-popup {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
  margin-left: 0.5rem !important;
  
}
`;
if (typeof document !== 'undefined' && !document.getElementById('custom-datepicker-popup-style')) {
  const style = document.createElement('style');
  style.id = 'custom-datepicker-popup-style';
  style.innerHTML = datePickerPopupStyle;
  document.head.appendChild(style);
}

export default function DatePickerComponent({ defaultValues, onUserInput, readonly }) {
  // Convert defaultValues to Date if string
  const [selectedDate, setSelectedDate] = React.useState(
    defaultValues ? new Date(defaultValues) : null
  );

  const handleChange = (date) => {
    setSelectedDate(date);
    onUserInput(date);
  };
  const popperContainer = ({ children }) => ReactDOM.createPortal(children, document.body);

  return (
    <DatePicker
      className="form-control form-control-sm text-start p-0 m-0 text-primary"
      selected={selectedDate}
      disabled={readonly}
      onChange={handleChange}
      dateFormat="yyyy-MM-dd"
      placeholderText="Select date"
      isClearable
      showYearDropdown
      showMonthDropdown
      dropdownMode="select"
      popperClassName="custom-datepicker-popup"
      popperContainer={popperContainer}
      renderCustomHeader={({ date, changeYear, changeMonth }) => {
        const years = [];
        const currentYear = new Date().getFullYear();
        for (let i = currentYear - 100; i <= currentYear + 20; i++) {
          years.push(i);
        }
        return (
          <div className="d-flex justify-content-between align-items-center mb-2 gap-2 px-2">
            <select
              className="form-control form-control-sm me-2"
              value={date.getFullYear()}
              onChange={({ target: { value } }) => changeYear(Number(value))}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <select
              className="form-control form-control-sm"
              value={date.getMonth()}
              onChange={({ target: { value } }) => changeMonth(Number(value))}
            >
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((month, idx) => (
                <option key={month} value={idx}>
                  {month}
                </option>
              ))}
            </select>
          </div>
        );
      }}
    />
  );
}
